import React from 'react';
import { Link, withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import Paginations from '../../common/paginations';
import constant from '../../../constant';

const ShipTypeList = ({ data, setCurrentPage, limit, onChangeVisibility }) => {
    const { types, total, page } = data;

    return (
        <React.Fragment>
            <div className="table-responsive">
                <table className="table align-middle table-hover">
                    <thead className="table-light">
                        <tr>
                            <th>#</th>
                            <th>Ship Type Name</th>
                            <th>Ship Type Code</th>
                            <th>Note</th>
                            <th>Status</th>
                            <th>Modified By</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {types?.length > 0 ? (
                            types.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        <div className="avatar-xs">
                                            <span className="avatar-title rounded-circle bg-light text-primary">
                                                {item.SHIP_TYPE_NAME?.charAt(0).toUpperCase()}
                                            </span>
                                        </div>
                                    </td>
                                    <td>{item.SHIP_TYPE_NAME}</td>
                                    <td>{item.SHIP_TYPE_CODE}</td>
                                    <td>{item.NOTE || '-'}</td>
                                    <td>
                                        <span
                                            className={`badge rounded-pill ${
                                                item.IS_ACTIVE ? 'bg-success' : 'bg-secondary'
                                            }`}
                                        >
                                            {item.IS_ACTIVE ? 'Active' : 'Inactive'}
                                        </span>
                                    </td>
                                    <td>{item.MODIFIED_BY_NAME || '-'}</td>
                                    <td>
                                        <ul className="list-inline font-size-20 contact-links mb-0">
                                            <li className="list-inline-item">
                                                <Link
                                                    to={{
                                                        pathname: constant.Authedcomponent.editShipTypeMasterData.url,
                                                        state: {
                                                            data: btoa(JSON.stringify(item)),
                                                            page: page,
                                                        },
                                                    }}
                                                    title="Edit"
                                                >
                                                    <i className="bx bx-edit text-primary"></i>
                                                </Link>
                                            </li>
                                            <li className="list-inline-item">
                                                <a
                                                    href="javascript:void(0);"
                                                    onClick={() => onChangeVisibility(item)}
                                                    title="Change Status"
                                                    className="text-danger"
                                                >
                                                    <i className={`bx ${item.IS_ACTIVE ? 'bx-trash' : 'bx-undo'}`} />
                                                </a>
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" className="text-center">
                                    No Ship Types found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <Paginations
                limit={limit}
                totalCount={total}
                range={5}
                currentPage={page}
                onPageChange={setCurrentPage}
            />
        </React.Fragment>
    );
};

export default withRouter(ShipTypeList);
